import { _ as e } from "./tslib.es6-7f1b1220.js";
import { c as t, u as i, h as r, n } from "./lit-element-161a1699.js";
import { p as o, a, c as u } from "./decorators-7e9cd43b.js";
import "./class-map-31af68b2.js";
import { BaseElement as p } from "./BaseElement.esm.min.js";
import { h as l } from "./host.styles-cf05db22.js";
import { e as s } from "./event.decorator-98549cbc.js";
import "./interactive-icon.component.esm.min.js";
import { i as m } from "./if-defined-123567fc.js";
import "./types-814d68fb.js";
import { isDefined as d } from "./component.utils.esm.min.js";
import { traverseDOMSiblingsByStepAndDirection as c } from "./dom.utils.esm.min.js";
import "./delegate-focus.mixin-95600d1f.js";
import "./style-map-a37d7105.js";
import "./_commonjsHelpers-82e0321a.js";
import { g as h, l as v } from "./date-picker.utils-7bc542a5.js";
import "./date-picker-input-part.component-63342ded.js";
import { h as y, e as b, a as k, t as _ } from "./time-picker.utils-e0fd0976.js";
import "./interactive-text.component.esm.min.js";
import "./time-picker-day-time-toggle.component.esm.min.js";
import "./time-picker-cell.component.esm.min.js";
import "./time-picker.component.esm.min.js";
import "./time-picker-input-part-1e800973.js";
import "./time-picker-input-part-day-time.component.esm.min.js";
import "./time-picker-input-part-number.component.esm.min.js";
var f;
const g = t`${i(":host {\n  --zui-time-picker-input-hour-placeholder-width: calc(var(--zui-gu) * 2.5);\n  --zui-time-picker-input-minute-placeholder-width: calc(var(--zui-gu) * 3);\n  --zui-time-picker-input-width: 100%;\n  ---zui-time-picker-input-color-border-bottom: var(--zui-color-input-bottom-line-default-enabled);\n  align-items: center;\n  border-bottom: 1px solid var(---zui-time-picker-input-color-border-bottom);\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: calc(var(--zui-gu) * 0.125);\n  width: var(--zui-time-picker-input-width);\n}\n\n:host(:hover) {\n  border-bottom-color: var(--zui-color-input-bottom-line-default-hover);\n}\n\n:host(:focus-within) {\n  border-bottom-color: var(--zui-color-input-bottom-line-default-focused);\n}\n\n:host([invalid]),\n:host([invalid]):host(:focus-within),\n:host([invalid]:hover) {\n  border-bottom-color: var(--zui-color-error);\n}\n\n:host(:hover),\n:host(:focus-within),\n:host([invalid]) {\n  border-bottom-width: 2px;\n  padding-bottom: 0;\n}\n\n:host([readonly]) {\n  border-bottom-width: 0;\n  padding-bottom: 2px;\n}\n\n:host([disabled]) {\n  border-bottom-color: var(--zui-time-picker-input-border-bottom-disabled-color);\n  pointer-events: none;\n}\n\n.time-picker-input-parts {\n  align-items: center;\n  display: flex;\n}\n:host([disabled]) .time-picker-input-parts {\n  opacity: var(--zui-disabled-opacity);\n}\n.time-picker-input-parts zui-time-picker-input-part-number#hour {\n  --zui-time-picker-input-part-number-placeholder-width: var(--zui-time-picker-input-hour-placeholder-width);\n}\n.time-picker-input-parts zui-time-picker-input-part-number#minute {\n  --zui-time-picker-input-part-number-placeholder-width: var(--zui-time-picker-input-minute-placeholder-width);\n}\n\n.time-picker-input-part-literal {\n  color: var(--zui-color-placeholder-input);\n  font: var(--zui-typography-body);\n}\n:host([value]) .time-picker-input-part-literal, :host(:focus-within) .time-picker-input-part-literal {\n  color: var(--zui-color-text-default);\n}\n.time-picker-input-part-literal::selection {\n  background: var(--zui-color-selection-background);\n}")}`;
let T = f = class extends p {
  constructor() {
    super(...arguments), this.disabled = !1, this.invalid = !1, this.locale = h(), this.placeholderDayTime = "AM", this.placeholderHour = "HH", this.placeholderMinute = "MM", this.readonly = !1, this.stepHour = 1, this.stepMinute = 1, this._isValidNextElement = e => "zui-time-picker-input-part-number" === e.tagName.toLowerCase() || "zui-time-picker-input-part-day-time" === e.tagName.toLowerCase();
  }
  static get styles() {
    return [l, g];
  }
  get hourCycle() {
    return this._internalHourCycle ? this._internalHourCycle : y(this.locale) ? "h12" : "h23";
  }
  set hourCycle(e) {
    const t = this._internalHourCycle;
    this._internalHourCycle = e, this.requestUpdate("hourCycle", t);
  }
  emitTimePickerInputInputEvent(e) {
    this.dispatchEvent(new CustomEvent("time-picker-input-input", {
      bubbles: !0,
      composed: !0,
      detail: e
    }));
  }
  emitTimePickerInputChangedEvent(e) {
    var t;
    this.dispatchEvent(new CustomEvent("time-picker-input-changed", {
      bubbles: !0,
      composed: !0,
      detail: {
        value: null !== (t = null == e ? void 0 : e.toISO()) && void 0 !== t ? t : null
      }
    }));
  }
  emitTimePickerInputToggleEvent() {
    this.dispatchEvent(new CustomEvent("time-picker-input-toggle", {
      bubbles: !0,
      composed: !0
    }));
  }
  get _is12HourFormat() {
    return "h12" === this.hourCycle;
  }
  get _literal() {
    return v.DateTime.now().setLocale(this.locale).toLocaleParts({
      hour: "numeric",
      minute: "numeric"
    }).find(({
      type: e
    }) => "literal" === e).value;
  }
  get _hideLiteral() {
    return this.readonly && !d(this.value);
  }
  _handleFocusNextTimePickerInputPart(e) {
    var t;
    null === (t = c(e.target, "next", 1, this._isValidNextElement)) || void 0 === t || t.focus();
  }
  _handleFocusPreviousTimePickerInputPart(e) {
    var t;
    null === (t = c(e.target, "previous", 1, this._isValidNextElement)) || void 0 === t || t.focus();
  }
  _handleHourCycleChange() {
    d(this.value) && (this.value = b(this.value, this.hourCycle));
  }
  _updateValue() {
    var e, t, i;
    const r = !d(null === (e = this.value) || void 0 === e ? void 0 : e.hour) || !d(null === (t = this.value) || void 0 === t ? void 0 : t.minute) || this._is12HourFormat && !d(null === (i = this.value) || void 0 === i ? void 0 : i.dayTime) ? void 0 : k({
      hour: this.value.hour,
      minute: this.value.minute
    }, v.DateTime.now(), this._is12HourFormat ? "h12" : "h23", this.value.dayTime);
    this.emitTimePickerInputChangedEvent(r);
  }
  _handleTimePickerInputPartHourChangedEvent() {
    var e;
    this.value = Object.assign(Object.assign({}, this.value), {
      hour: null !== (e = this._inputHourRef.value) && void 0 !== e ? e : void 0
    }), this._updateValue();
  }
  _handleTimePickerInputPartMinuteChangedEvent() {
    var e;
    this.value = Object.assign(Object.assign({}, this.value), {
      minute: null !== (e = this._inputMinuteRef.value) && void 0 !== e ? e : void 0
    }), this._updateValue();
  }
  _handleTimePickerInputPartDayTimeChangedEvent() {
    var e;
    this.value = Object.assign(Object.assign({}, this.value), {
      dayTime: null !== (e = this._inputDayTimeRef.value) && void 0 !== e ? e : void 0
    }), this._updateValue();
  }
  _handleTimePickerInputEvent(e) {
    var t;
    this.emitTimePickerInputInputEvent({
      dayTime: e.target === this._inputDayTimeRef ? e.detail.value : null === (t = this._inputDayTimeRef) || void 0 === t ? void 0 : t.value,
      hour: e.target === this._inputHourRef ? e.detail.value : this._inputHourRef.value,
      minute: e.target === this._inputMinuteRef ? e.detail.value : this._inputMinuteRef.value
    });
  }
  _handleTimePickerInputPartHourKeydownEvent(e) {
    if (!this.readonly && e.key === this._literal) e.preventDefault(), this._handleFocusNextTimePickerInputPart(e);
  }
  updated(e) {
    super.updated(e), e.has("hourCycle") && this._handleHourCycleChange();
  }
  render() {
    var e, t, i, o, a;
    return r`<div class="time-picker-input-parts" @time-picker-input-part-focus-next="${this._handleFocusNextTimePickerInputPart}" @time-picker-input-part-focus-previous="${this._handleFocusPreviousTimePickerInputPart}" @time-picker-input-part-number-input="${this._handleTimePickerInputEvent}"><zui-time-picker-input-part-number ?disabled="${this.disabled}" ?readonly="${this.readonly}" id="hour" max="${this._is12HourFormat ? f.MAX_12_HOURS : f.MAX_24_HOURS}" min="${this._is12HourFormat ? f.MIN_12_HOURS : f.MIN_24_HOURS}" placeholder="${this.placeholderHour}" step="${this.stepHour}" value="${m(null === (e = this.value) || void 0 === e ? void 0 : e.hour)}" default-value="${m(null === (t = this.defaultValue) || void 0 === t ? void 0 : t.hour)}" @keydown="${this._handleTimePickerInputPartHourKeydownEvent}" @time-picker-input-part-number-changed="${this._handleTimePickerInputPartHourChangedEvent}"></zui-time-picker-input-part-number><span class="time-picker-input-part-literal" ?hidden="${this._hideLiteral}">${this._literal}</span><zui-time-picker-input-part-number ?disabled="${this.disabled}" ?readonly="${this.readonly}" id="minute" max="${f.MAX_MINUTES}" min="${f.MIN_MINUTES}" placeholder="${this.placeholderMinute}" step="${this.stepMinute}" value="${m(null === (i = this.value) || void 0 === i ? void 0 : i.minute)}" default-value="${m(null === (o = this.defaultValue) || void 0 === o ? void 0 : o.minute)}" @time-picker-input-part-number-changed="${this._handleTimePickerInputPartMinuteChangedEvent}"></zui-time-picker-input-part-number>${this._is12HourFormat ? r`<zui-time-picker-input-part-day-time ?disabled="${this.disabled}" ?readonly="${this.readonly}" placeholder="${this.placeholderDayTime}" value="${m(null === (a = this.value) || void 0 === a ? void 0 : a.dayTime)}" @time-picker-input-part-day-time-changed="${this._handleTimePickerInputPartDayTimeChangedEvent}" @time-picker-input-part-day-time-input="${this._handleTimePickerInputEvent}"></zui-time-picker-input-part-day-time>` : n}</div><zui-interactive-icon ?disabled="${this.disabled || this.readonly}" @click="${this.emitTimePickerInputToggleEvent}"><zui-icon-time-time-time size="m"></zui-icon-time-time-time></zui-interactive-icon>`;
  }
};
T.MAX_12_HOURS = 12, T.MAX_24_HOURS = 23, T.MIN_12_HOURS = 1, T.MIN_24_HOURS = 0, T.MAX_MINUTES = 59, T.MIN_MINUTES = 0, T.MAX_CHARACTER_LENGTH = 2, e([o({
  reflect: !0,
  type: Boolean
})], T.prototype, "disabled", void 0), e([o({
  reflect: !0,
  type: String,
  attribute: "hour-cycle"
})], T.prototype, "hourCycle", null), e([o({
  reflect: !0,
  type: Boolean
})], T.prototype, "invalid", void 0), e([o({
  reflect: !0,
  type: String
})], T.prototype, "locale", void 0), e([o({
  reflect: !0,
  type: String,
  attribute: "placeholder-day-time"
})], T.prototype, "placeholderDayTime", void 0), e([o({
  reflect: !0,
  type: String,
  attribute: "placeholder-hour"
})], T.prototype, "placeholderHour", void 0), e([o({
  reflect: !0,
  type: String,
  attribute: "placeholder-minute"
})], T.prototype, "placeholderMinute", void 0), e([o({
  reflect: !0,
  type: Boolean
})], T.prototype, "readonly", void 0), e([o({
  reflect: !0,
  type: Number,
  attribute: "step-hour"
})], T.prototype, "stepHour", void 0), e([o({
  reflect: !0,
  type: Number,
  attribute: "step-minute"
})], T.prototype, "stepMinute", void 0), e([o({
  reflect: !0,
  type: String,
  converter: _
})], T.prototype, "value", void 0), e([o({
  reflect: !0,
  type: String,
  attribute: "default-value",
  converter: _
})], T.prototype, "defaultValue", void 0), e([s()], T.prototype, "emitTimePickerInputInputEvent", null), e([s()], T.prototype, "emitTimePickerInputChangedEvent", null), e([s()], T.prototype, "emitTimePickerInputToggleEvent", null), e([a("zui-time-picker-input-part-number#hour")], T.prototype, "_inputHourRef", void 0), e([a("zui-time-picker-input-part-number#minute")], T.prototype, "_inputMinuteRef", void 0), e([a("zui-time-picker-input-part-day-time")], T.prototype, "_inputDayTimeRef", void 0), T = f = e([u("zui-time-picker-input")], T);
export { T as TimePickerInput };
